



















import { Component, Prop, Vue, Mixins } from 'vue-property-decorator';
import RequestsService from '@/mixins/requests.service';
import FiltersService from '@/mixins/filters.service';
import { LeaveTypeId } from '@/types/request';

@Component({
  mixins: [ RequestsService, FiltersService ],
})
export default class UserFilter extends Mixins(RequestsService, FiltersService) {

  private onSelectedLeaveTypes(leaveTypes: LeaveTypeId[]) {
    this.$store.commit('leaveTypes/setSelected', leaveTypes);
  }

}
